(function (utils, $) {

  var YT = null;

  function isYouTubeVideo(src) {
    if (!src) { return false; }
    return (src.indexOf('youtube.com/') !== -1 || src.indexOf('youtu.be/') !== -1);
  }

  function sendHelpVideoEvent(state, player) {
    var video = player.getVideoUrl();
    var time = player.getCurrentTime();
    ux.traffic.custom('notify', 'mcx.help.article.video', [
      ['video', video],
      ['time', time],
      ['state', state],
      ['split', ''],
      ['inapp', gdhelp2.utils.inIframe()],
      ['internal', requestContext.internalRequest],
      ['plId', 'requestContext.plId']
    ]);
  }

  function helpVideoOnStateChange(event) {
    if (event.data === YT.PlayerState.UNSTARTED) {
      sendHelpVideoEvent('init', event.target);
    } else if (event.data === YT.PlayerState.PLAYING) {
      $('.help-video').addClass('help-video-enlarge');
      sendHelpVideoEvent('play', event.target);
    } else if (event.data === YT.PlayerState.PAUSED) {
      sendHelpVideoEvent('pause', event.target);
    } else if (event.data === YT.PlayerState.ENDED) {
      sendHelpVideoEvent('end', event.target);
    }
  }

  function updateVideoOptions(iframe) {
    var hasQs = (iframe.src.indexOf('?') !== -1);
    iframe.src += (hasQs ? '&' : '?') + 'rel=0&enablejsapi=1&origin=' +
      document.location.origin;
  }

  function bindYTPlayerEvents(iframe) {
    if (YT) {
      // eslint-disable-next-line no-new
      new YT.Player(iframe.id, { events: {
        onStateChange: helpVideoOnStateChange
      } });
    }
  }

  function bindHelpVideoEvents() {
    if (YT === null && window.YT && window.YT.loaded && window.YT.Player) {
      YT = window.YT;
      var iframes = $('iframe');
      if (iframes.length) {
        for (var i = 0, len = iframes.length; i < len; i++) {
          var iframe = iframes[i];
          if (isYouTubeVideo(iframe.src)) {
            if (!iframe.id) {
              iframe.id = 'help-yt-' + (i + 1);
            }
            bindYTPlayerEvents(iframe);
          }
        }
      }
    }
  }

  function notifyHelpVideoChanged(helpVideoId) {
    var $iframe = $('#' + helpVideoId);
    if ($iframe.length) {
      var iframe = $iframe[0];
      updateVideoOptions(iframe);
      bindYTPlayerEvents(iframe);
    }
  }

  // eslint-disable-next-line max-statements
  function ready() {
    if (typeof requestContext === 'undefined') { return; }

    if (requestContext.market !== 'zh-SG' && requestContext.market !== 'zh-CN') {

      var ytApi = false;
      var iframes = document.getElementsByTagName('iframe');

      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];
        if (iframe.src.indexOf('youtube.com') > -1) {
          ytApi = true;

          var hasQs = (iframe.src.indexOf('?') !== -1);
          iframe.src += (hasQs ? '&' : '?') + 'rel=0&enablejsapi=1&origin=' +
            document.location.origin;
        }
      }

      if (ytApi) {
        var firstScriptTag = document.getElementsByTagName('script')[0];
        var tag = document.createElement('script');
        tag.src = '//www.youtube.com/iframe_api';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }

    }
  }

  window.onYouTubeIframeAPIReady = function () {
    bindHelpVideoEvents();
  };

  utils.bindHelpVideoEvents = bindHelpVideoEvents;
  utils.notifyHelpVideoChanged = notifyHelpVideoChanged;

  $(document).ready(ready);

}(gdhelp2.utils, jQuery));
